import { Switch, Route, Router, Redirect } from 'react-router-dom';
import { privateRoutesPath, publicRoutesPath } from './Routes/index';
import PrivateRoute from './Routes/PrivateRoute';
import PublicRoute from './Routes/PublicRoute';
import history from './Utility/history';
import './App.css';

function App() {
  
  return (
    <Router history={history}>
      <Switch>
        <Route component={PrivateRoute} path={privateRoutesPath.BIZTANTU} />
        <Route exact path={Object.values(publicRoutesPath)} component={PublicRoute} />
        <Redirect to={publicRoutesPath.LOGIN} />
      </Switch>
    </Router>
  );
}

export default App;
